import { render, staticRenderFns } from "./CreatePostForm.vue?vue&type=template&id=594111a8&scoped=true&"
import script from "./CreatePostForm.vue?vue&type=script&lang=js&"
export * from "./CreatePostForm.vue?vue&type=script&lang=js&"
import style0 from "./CreatePostForm.vue?vue&type=style&index=0&id=594111a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594111a8",
  null
  
)

export default component.exports